module.exports = __webpack_public_path__ + "static/hero-f8d079b559262772ef64d345f7085caf.png";